<ngx-loading [show]="loading" [config]="{ backdropBackgroundColour: 'rgba(0,0,0,0.6)' }" #customLoadingTemplate></ngx-loading>
<div *ngIf="creditCardPayments" class="containerSearchTxt">
  <button class="btn btn-outline btn-refresh" style="border-color: transparent !important;" [disabled]="loading" (click)="refrehPage()">
    <img title="Atualizar" style="cursor: hand; cursor: pointer; height: 24px; width: 24px; cursor: inherit; margin-right: 15px;" src="/update.svg" />
  </button>
  <button class="btn btn-outline btn-refresh" style="border-color: transparent !important;" [disabled]="loading">
    <img title="Buscar" style="height: 24px; width: 24px; cursor: inherit; margin-right: 5px;" src="/search.svg" />
  </button>

  <!-- Selecione se deve apresentar pagamentos com erro de integração -->
  <mat-form-field class="select-form origin-filter">
    <mat-label>
      Erro na integração
    </mat-label>
    <mat-select matInput name="integrationErroFilter" [(value)]="integrationErroSelected" class="filter-field">
      <mat-option (click)="changeIntegrationErro(null)" value="">Selecione</mat-option>
      <mat-option (click)="changeIntegrationErro('true')" value="true">Apenas com erro</mat-option>
      <mat-option (click)="changeIntegrationErro('false')" value="false">Apenas sem erro</mat-option>
    </mat-select>
  </mat-form-field>

  <input type="text" (ngxInputSearch)="doSearch($event)"
         (emptyInput)="doSearchClear()"
         stringLength="0" class="searchTxt" placeholder="TID/NOME/CPF/CNPJ/OV/PEDIDO" />
</div>

<div>
  <nav mat-tab-nav-bar>
    <a mat-tab-link [routerLink]="['/credit-card-payment']">Cartão de crédito</a>
    <a mat-tab-link [routerLink]="['/debit-card-payment']">Cartão de débito</a>
    <a mat-tab-link [routerLink]="['/pix-payment']">Pix</a>
  </nav>
</div>

<div>
  <p *ngIf="!creditCardPayments && !loading"><em>Sem dados</em></p>
  <table class='table table-striped' aria-labelledby="tableLabel" align="center" *ngIf="creditCardPayments">
    <thead>
      <tr>
        <th style="text-align:center;">Nome</th>
        <th style="text-align:center;">Status</th>
        <th style="text-align:center;">CPF/CNPJ (Pagador)</th>
        <th style="text-align:center;">CPF/CNPJ (Comprador)</th>
        <th style="text-align:center;">TID</th>
        <th style="text-align:center;">Ordem de venda</th>
        <th style="text-align:center;">Pedido</th>
        <th style="text-align:center;">Valor</th>
        <th style="text-align:center;">Data do pagamento</th>
        <th style="text-align:center;">Bandeira</th>
        <th style="text-align:center;">Situação</th>
        <th></th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let creditCardItem of creditCardPayments | paginate: { id: 'CreditCard', itemsPerPage: pageSize, currentPage: p, totalItems: total }; let i = index">
        <td style="min-width: 200px; max-width: 200px;" title="{{ creditCardItem.customer.name }}">{{ creditCardItem.customer.name }}</td>
        <td title="{{ creditCardItem.payment.providerStatus }}" style="text-align:center;">{{ creditCardItem.payment.providerStatus }}</td>
        <td title="{{ creditCardItem.payment.documentNumber }}" style="text-align:center;">{{ creditCardItem.payment.documentNumber }}</td>
        <td title="{{ creditCardItem.payment.buyerDocumentNumber }}" style="text-align:center;">{{ creditCardItem.payment.buyerDocumentNumber }}</td>
        <td title="{{ creditCardItem.payment.tid }}" style="text-align:center;">{{ creditCardItem.payment.tid }}</td>
        <td title="{{ creditCardItem.salesId }}" style="text-align:center;">{{ creditCardItem.salesId }}</td>
        <td title="{{ creditCardItem.orderNumber }}" style="text-align:center;">{{ creditCardItem.orderNumber }}</td>
        <td title="{{ creditCardItem.payment.amountFormated }}" style="text-align:center;">{{ creditCardItem.payment.amountFormated }}</td>
        <td title="{{ creditCardItem.payment.receivedDateFormated }}" style="text-align:center;">{{ creditCardItem.payment.receivedDateFormated }}</td>
        <td style="text-align:center;"> <img class="brand" src="{{ creditCardItem.payment.creditCard.brandImage }}" /></td>

        <td *ngIf="!creditCardItem.payment.canceled && creditCardItem.payment.captured" title="Capturado" style="text-align:center;">
          <img class="status" style="cursor: inherit;" src="/ok.svg" />
        </td>
        <td *ngIf="creditCardItem.payment.canceled" style="text-align:center;" title="Cancelado">
          <img class="status" style="cursor: inherit;" src="/canceled.svg" />
        </td>
        <td *ngIf="!creditCardItem.payment.canceled && !creditCardItem.payment.captured" title="Processando" style="text-align:center;">
          <img class="status" style="cursor: inherit;" src="/loading.svg" />
        </td>
        <td style="text-align:center;">
          <button class="btn btn-outline" style="border-color: transparent !important;" [disabled]="loading" (click)="openModal('modalDetailPaymentCreditCard', i, $event)">
            <img style="cursor: pointer; border-radius: 20px;" src="/detail.svg" class="btn-img-nocircle details" />
          </button>
        </td>
      </tr>
    </tbody>
    <tfoot>
      <tr>
        <td colspan="12">
          <pagination-controls id="CreditCard"
                               (pageChange)="pageChanged($event)"
                               (pageBoundsCorrection)="pageChanged($event)"
                               maxSize="9"
                               directionLinks="true"
                               autoHide="true"
                               responsive="true"
                               previousLabel="anterior"
                               nextLabel="próximo"
                               screenReaderPaginationLabel="Paginação"
                               screenReaderPageLabel="pagina"
                               screenReaderCurrentLabel="você esta na página">
          </pagination-controls>
        </td>
      </tr>
    </tfoot>
  </table>
  <!--Details Modal-->
  <div class="container">
    <div class="modal" id="modalDetailPaymentCreditCard" role="dialog">
      <div class="modal-dialog" style="width: 70%; height: 95%; max-width: none;">
        <div class="modal-content">
          <div class="modal-header">
            <h3>Detalhes da transação</h3>
            <button type="button" class="btn btn-default btnCloseModal" data-dismiss="modal" (click)="closeModal('modalDetailPaymentCreditCard')">Fechar</button>
          </div>
          <div class="modal-body row" *ngIf="creditCardPayment">
            <div class="col-7">
              <div class="row panel-cartao">
                <div class="col-8 text-right h4">{{ creditCardPayment.payment.amountFormated }} </div>
                <div class="col-4 h5">{{ creditCardPayment.payment.currency }} </div>
                <div class="col-12">{{ creditCardPayment.customer.name }} </div>
                <div class="col-12">Documento: {{ creditCardPayment.customer.documentNumber }} </div>
                <div class="col-12 text-small">ID: {{ creditCardPayment.id }} </div>
                <div class="col-12 text-small">OrderID: {{ creditCardPayment.orderId }} </div>
              </div>
            </div>
            <div class="col-5">
              <div class="row panel-cartao">

                <div class="col-3"><img src="{{ creditCardPayment.payment.creditCard.brandImage }}" style="width: 83px;" /></div>
                <div class="col-9">
                  <div class="col-12">{{ creditCardPayment.payment.creditCard.brand }} {{ creditCardPayment.payment.creditCard.cardNumber }}</div>
                  <div class="col-12">{{ creditCardPayment.payment.creditCard.holder }}</div>
                  <div class="col-12">{{ creditCardPayment.payment.installments }}X {{creditCardPayment.payment.amountInstallments}} = {{ creditCardPayment.payment.amountFormated }}</div>
                </div>
                <div class="col-12 text-small">TID: {{ creditCardPayment.payment.tid }} </div>
                <div class="col-12 text-small">NSU: {{ creditCardPayment.payment.nsu }} </div>
                <div class="col-12 text-small">Autenticação: {{ creditCardPayment.payment.authorization }} </div>
                <div class="{{ creditCardPayment.classStatus }}">{{ creditCardPayment.textStatus }}</div>
              </div>
            </div>

          </div>
          <div class="modal-body" style="max-height: calc(100vh - 366px); overflow-y: auto;">

            <ejs-accordion>

              <div>
                <!-- accordin item -->
                <div>
                  <!-- accordin header -->
                  <div>Detalhes do pagamento</div>
                </div>
                <div>
                  <!-- accordin painel -->
                  <div>
                    <!-- accordin content -->
                    <div class="row">
                      <!--<div class="col-4">
    <label for="basic-url">Identificação do pagamento</label>
    <input style="float: left;" *ngIf="creditCardPayment" [(ngModel)]="creditCardPayment.id" type="text" class="form-control" required disabled>
  </div>
  <div class="col-4">
    <label for="basic-url">TID</label>
    <input style="float: left;" *ngIf="creditCardPayment" [(ngModel)]="creditCardPayment.payment.tid" type="text" class="form-control" required disabled>
  </div>-->
                      <div class="col-3">
                        <label for="basic-url">Parcelas</label>
                        <input style="float: left;" *ngIf="creditCardPayment" [(ngModel)]="creditCardPayment.payment.installments" type="text" class="form-control" required disabled>
                      </div>
                      <div class="col-3">
                        <label for="basic-url">Juros</label>
                        <input style="float: left;" *ngIf="creditCardPayment" [(ngModel)]="creditCardPayment.payment.interest" type="text" class="form-control" required disabled>
                      </div>
                      <div class="col-3">
                        <label for="basic-url">País</label>
                        <input style="float: left;" *ngIf="creditCardPayment" [(ngModel)]="creditCardPayment.payment.country" type="text" class="form-control" required disabled>
                      </div>
                      <div class="col-3">
                        <label for="basic-url">Soft Descriptor</label>
                        <input style="float: left;" *ngIf="creditCardPayment" [(ngModel)]="creditCardPayment.payment.softDescriptor" type="text" class="form-control" required disabled>
                      </div>

                      <div class="col-12 title-detail">
                        Informações do Adquirente
                      </div>
                      <div class="col-4">
                        <label for="basic-url">Merchant OrderId</label>
                        <input style="float: left;" *ngIf="creditCardPayment" [(ngModel)]="creditCardPayment.merchantOrderId" type="text" class="form-control" required disabled>
                      </div>
                      <div class="col-2">
                        <label for="basic-url">Provider</label>
                        <input style="float: left;" *ngIf="creditCardPayment" [(ngModel)]="creditCardPayment.payment.provider" type="text" class="form-control" required disabled>
                      </div>
                      <div class="col-2">
                        <label for="basic-url">Código de retorno</label>
                        <input style="float: left;" *ngIf="creditCardPayment" [(ngModel)]="creditCardPayment.payment.returnCode" type="text" class="form-control" required disabled>
                      </div>
                      <div class="col-4">
                        <label for="basic-url">Mensagem de retorno</label>
                        <input style="float: left;" *ngIf="creditCardPayment" [(ngModel)]="creditCardPayment.payment.returnMessage" type="text" class="form-control" required disabled>
                      </div>
                      <div class="col-4">
                        <label for="basic-url">ID do pagamento</label>
                        <input style="float: left;" *ngIf="creditCardPayment" [(ngModel)]="creditCardPayment.payment.paymentId" type="text" class="form-control" required disabled>
                      </div>


                      <div class="col-12 title-detail">
                        Status do pagamento
                      </div>
                      <div class="col-4">
                        <label for="basic-url">Data do pagamento</label>
                        <input style="float: left;" *ngIf="creditCardPayment" [(ngModel)]="creditCardPayment.payment.receivedDateFormated" type="text" class="form-control" required disabled>
                      </div>
                      <div class="col-4">
                        <label for="basic-url">Data de Cancelamento</label>
                        <input style="float: left;" *ngIf="creditCardPayment" [(ngModel)]="creditCardPayment.payment.canceledDateFormated" type="text" class="form-control" required disabled>
                      </div>
                      <div class="col-4">
                        <label for="basic-url">Data de Captura</label>
                        <input style="float: left;" *ngIf="creditCardPayment" [(ngModel)]="creditCardPayment.payment.capturedDateFormated" type="text" class="form-control" required disabled>
                      </div>
                      <div class="col-4">
                        <label for="basic-url">Status do Provider</label>
                        <input style="float: left;" *ngIf="creditCardPayment" [(ngModel)]="creditCardPayment.payment.providerStatus" type="text" class="form-control" required disabled>
                      </div>
                      <div class="col-6">
                        <label for="basic-url">Descrição do Status Provider</label>
                        <input style="float: left;" *ngIf="creditCardPayment" [(ngModel)]="creditCardPayment.payment.providerStatusDescription" type="text" class="form-control" required disabled>
                      </div>
                      <div class="col-4">
                        <label for="basic-url">Status Interno</label>
                        <input style="float: left;" *ngIf="creditCardPayment" [(ngModel)]="creditCardPayment.payment.internalStatus" type="text" class="form-control" required disabled>
                      </div>
                      <div class="col-6">
                        <label for="basic-url">Descrição do Status Interno</label>
                        <input style="float: left;" *ngIf="creditCardPayment" [(ngModel)]="creditCardPayment.payment.internalStatusDescription" type="text" class="form-control" required disabled>
                      </div>


                      <div class="col-12 title-detail">
                        Informações do Antifraude
                      </div>
                      <div class="col-4">
                        <label for="basic-url">Status do FraudAnalisys</label>
                        <input style="float: left;" *ngIf="creditCardPayment" [(ngModel)]="creditCardPayment.payment.fraudAnalisysStatus" type="text" class="form-control" required disabled>
                      </div>
                      <div class="col-4">
                        <label for="basic-url">Descrição do Status FraudAnalisys</label>
                        <input style="float: left;" *ngIf="creditCardPayment" [(ngModel)]="creditCardPayment.payment.fraudAnalisysStatusDescription" type="text" class="form-control" required disabled>
                      </div>
                      <div class="col-4">
                        <label for="basic-url">Data de Aprovação do Antifraude</label>
                        <input style="float: left;" *ngIf="creditCardPayment" [(ngModel)]="creditCardPayment.payment.FraudAnalisysDateFormated" type="text" class="form-control" required disabled>
                      </div>

                      <div class="col-12 title-detail">
                        Informações do Cartão
                      </div>
                      <div class="col-4">
                        <label for="basic-url">Nome impresso no cartão</label>
                        <input style="float: left;" *ngIf="creditCardPayment" [(ngModel)]="creditCardPayment.payment.creditCard.holder" type="text" class="form-control" required disabled>
                      </div>
                      <div class="col-3">
                        <label for="basic-url">Número do cartão</label>
                        <input style="float: left;" *ngIf="creditCardPayment" [(ngModel)]="creditCardPayment.payment.creditCard.cardNumber" type="text" class="form-control" required disabled>
                      </div>

                      <div class="col-3">
                        <label for="basic-url">Data de expiração</label>
                        <input style="float: left;" *ngIf="creditCardPayment" [(ngModel)]="creditCardPayment.payment.creditCard.expirationDate" type="text" class="form-control" required disabled>
                      </div>
                      <div class="col-2">
                        <label for="basic-url">Bandeira</label>
                        <input style="float: left;" *ngIf="creditCardPayment" [(ngModel)]="creditCardPayment.payment.creditCard.brand" type="text" class="form-control" required disabled>
                      </div>

                    </div>
                  </div>
                </div>
              </div>

              <div>
                <!-- accordin item -->
                <div>
                  <!-- accordin header -->
                  <div>Fluxo de pagamento</div>
                </div>
                <div>
                  <!-- accordin painel -->
                  <div>
                    <!-- accordin content -->
                    <div *ngFor="let log of logs; let i = index">
                      <div class="cardLog {{ log.type }}">
                        <div class="logDateCreation">
                          {{ log.creationDateFormated }}
                        </div>
                        <div class="logProviderType"><div class="img-log"></div>{{ log.providerType }} -&nbsp;</div>
                        <div class="logTitle">{{ log.title }}</div>
                        <br />
                        <div>
                          <div *ngIf="log.message" class="logMessageBtn" (click)="displayLog(log.id)">mais detalhes</div>
                          <div class="logMessage" id="{{ log.id }}">
                            <br />
                            <pre><code>{{ log.message }}</code></pre>
                          </div>
                        </div>
                      </div>
                    </div>


                    <!--Retentativa ou busca de antigos-->
                    <div style="text-align: center;" *ngIf="creditCardPayment && logError">
                      <button class="btn btn-outline " style="margin-right: 15px" (click)="getLogs(creditCardPayment.id, '')" title="Recarregar">Recarregar</button>
                      <button class="btn btn-outline " (click)="getLogs(creditCardPayment.id, 'old')" title="Carregar log antigo">Carregar log antigo</button>
                    </div>
                  </div>
                </div>
              </div>

            </ejs-accordion>

          </div>
          <div class="modal-footer" *ngIf="creditCardPayment && currentUser.userPermission.payment.write">
            <button class="btn btn-outline btnCancelPayment {{ creditCardPayment.classButtonCancel }}" [disabled]="loading || creditCardPayment.isDelivered" (click)="openNewDialog()">Cancelar pagamento</button>
            <button class="btn btn-outline {{ creditCardPayment.classButtonCapture }}" [disabled]="loading" (click)="capturePayment()">Capturar pagamento</button>
            <!--<button class="btn btn-outline " [disabled]="loading" (click)="sendConfirmToAx()">Enviar confirmação ao AX</button>-->
          </div> 
        </div>  
      </div>
    </div>
  </div>
</div>
